'use client'

import { Loader2 } from 'lucide-react'
import { useLogoutFlow } from '@/lib/commerce/hooks'

export default function Logout() {
  useLogoutFlow()
  return (
    <div className="w-full flex flex-col items-center text-center">
      <div className="text-[10px] font-semibold uppercase tracking-[0.22em]" style={{ color: '#a8a8b3' }}>Систем</div>
      <h1
        className="mt-3 font-semibold tracking-[-0.025em] leading-[0.95] text-white"
        style={{ fontFamily: 'Gilroy, Inter, sans-serif', fontSize: 'clamp(30px, 4vw, 38px)' }}
      >
        Гарж байна.
      </h1>
      <div className="mt-8 inline-flex items-center gap-2 text-[13.5px]" style={{ color: 'rgba(255,255,255,0.6)' }}>
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>Таныг системээс гаргаж байна. Түр хүлээнэ үү...</span>
      </div>
    </div>
  )
}
